import { EnvironmentConfig } from 'softcat:config/environment.ts';
import { PiqEnvironment } from 'softcat:config/piq-environment.ts';

const getName = (host: string) => {
    if (host.includes('localhost')) {
        return EnvironmentConfig.LocalhostEnvironmentProxy;
    }

    if (host.includes('staging')) {
        return PiqEnvironment.STAGE;
    }

    // Lab hosts are checked first so a zone name containing `dev` or `integration` cannot win.
    for (const environment of [PiqEnvironment.REF_LAB, PiqEnvironment.ETHAN_LAB]) {
        if (host.includes(environment.toLowerCase())) {
            return environment;
        }
    }

    for (const environment of Object.values(PiqEnvironment)) {
        if (host.includes(environment.toLowerCase())) {
            return environment as PiqEnvironment;
        }
    }

    return PiqEnvironment.PRODUCTION;
};

const getShortName = (host: string) => {
    const environmentShortNames = {
        [PiqEnvironment.DEV]: 'DEV',
        [PiqEnvironment.ETHAN_LAB]: 'ETH',
        [PiqEnvironment.INTEGRATION]: 'INT',
        [PiqEnvironment.PRODUCTION]: 'PRD',
        [PiqEnvironment.REF_LAB]: 'REF',
        [PiqEnvironment.STAGE]: 'STG',
    };

    return environmentShortNames[EnvironmentUtils.getName(host)];
};

// Non-persistent stages are served from `<stage>.console.<zone>`, for example `pr-281.console.<zone>`.
const getStageName = (host: string) => {
    return host.split('.')[0];
};

export const EnvironmentUtils = {
    getName,
    getShortName,
    getStageName,
};
